import { refreshAccessToken } from "../api";
import { getAuthInfosFromCookie } from "../utils";
import { APP_ENV } from "../config";
import { extractAuthContextFromJWT } from "../lib/jwt";
import { store } from "../store";
import { setCookie } from "../utils";
let refreshPromise = null;

import {
  setJwtToken,
  setRefreshToken,
  setExpiresIn,
  setTokenCreatedAt,
  setAuthToken,
  setAuthContext,
} from "../store";
export const getValidGoPeopleToken = async (forceRefresh = false) => {
  const auth = getAuthInfosFromCookie();
  if (!auth) throw new Error("No GoPeople auth stored");
  const createdAt = Number(auth.createdAt);
  const expiresIn = Number(auth.expiresIn);

  const expiresAt = createdAt * 1000 + expiresIn * 1000;
  const isTokenValid = auth.jwtToken && expiresAt > Date.now();


  if (!forceRefresh && isTokenValid) {
    return auth.jwtToken;
  }

  if (refreshPromise) {
    const tokens = await refreshPromise;
    return tokens.accessToken;
  }

  refreshPromise = (async () => {
    try {
      const newTokens = await refreshAccessToken(auth.refreshToken);

      const createdAt = Math.floor(Date.now() / 1000);
      const authC = extractAuthContextFromJWT(newTokens.accessToken);

      // JWT `exp` is an absolute Unix timestamp (seconds), not a duration.
      let dtExpire = new Date(authC.expiresAt * 1000);

      const dispatch = store.dispatch;

      if (authC) {
        // setAuthContext(authC);
        dispatch(setAuthToken(authC.ttpAccessToken));
      }
      dispatch(setExpiresIn(authC.expiresAt));
      dispatch(setTokenCreatedAt(authC.createdAt));
      // dispatch(setAuthScope(newTokens.scope));
      dispatch(setJwtToken(newTokens.jwtToken));
      dispatch(setRefreshToken(newTokens.refreshToken));

      if (authC?.ttpAccessToken) {
        dispatch(setAuthToken(authC.ttpAccessToken));
      }
      
      const updatedAuth = {
        ...auth,
        jwt: newTokens.accessToken,
        jwtToken: newTokens.accessToken,
        refreshToken: newTokens.refreshToken,
        expiresIn: authC.expiresAt - createdAt,
        createdAt,
      };

      setCookie(
        `ttp_auth_${APP_ENV}`,
        JSON.stringify(updatedAuth),
        dtExpire,
        "/",
        "unitedassociates.be"
      );
      setCookie(
        `ttp_auth_${APP_ENV}`,
        JSON.stringify(updatedAuth),
        dtExpire,
        "/"
      );

      return newTokens;
    } finally {
      refreshPromise = null;
    }
  })();

  const tokens = await refreshPromise;
  return tokens.accessToken;
};
